<template>
  <div class="wrapper">
    <header class="bg">
      <!-- <router-link to="/" class="back">← 返回首页</router-link> -->
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/vue.png" /></div>
      <p>Vue-Filter</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = 'https://uedcdn.zto.com/static/vue-filter/'
export default {
  name: 'index',
  data () {
    return {
      fileList: [{
        label: '0.2.5',
        linkList: [
          ur + '0.2.5/vue-filter.js',
          ur + '0.2.5/vue-filter.min.js'
        ]
      }, {
        label: '0.2.4',
        linkList: [
          ur + '0.2.4/vue-filter.js',
          ur + '0.2.4/vue-filter.min.js'
        ]
      }, {
        label: '0.2.3',
        linkList: [
          ur + '0.2.3/vue-filter.js',
          ur + '0.2.3/vue-filter.min.js'
        ]
      }]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/ListVueFilter.vue